import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'historySort'
})
export class HistorySortPipe implements PipeTransform {
  transform(chats: any[]): any[] {
    if (!chats) return [];

    return chats
      .sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()).slice(0,5)
  }
}